import { cn } from "@/lib/utils";

// Estado vacío ÚNICO (tipo tarjeta) para cuando una sección no tiene datos. Antes cada página lo
// pintaba distinto (unas con tarjeta, otras con un <p> suelto sin contexto). El "Cargando" sí estaba
// ya uniforme en todo el panel (p-8 text-muted-foreground), así que no se toca.
export function EmptyState({ message, className }: { message: string; className?: string }) {
  return (
    <div className={cn("rounded-lg border bg-card p-8 text-center text-sm text-muted-foreground", className)}>
      {message}
    </div>
  );
}
